import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeClaimDetails } from './normalize';

export const fetchClaimDetails = createProvider(api.fetchClaimDetails)
  .andThen((res) => normalizeClaimDetails(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch claim details aborted');
    } else {
      console.error('Fetch claim details was failed:', error);
    }
    throw error;
  });
